import React, { useEffect } from "react";
import { dataURLtoFile, savePhoneFile, uploadToQiNiu } from "API";
import useRequestFn from "Utils/useRequestFn";
import { Spin } from "antd";
import { errorMessage } from "Utils/useRequest";
import styles from "./index.module.scss";

interface UploadImageProps {
    examId: string;
    base64: string;
    onFinished(): void;
}

export default function UploadImage({
    examId,
    base64,
    onFinished
}: UploadImageProps) {
    const date = new Date();
    const [doSaveFile, { loading, error }] = useRequestFn(async () => {
        const file = dataURLtoFile(base64!, `capture${date.getTime()}.png`);
        //获取上传后七牛地址
        const data = await uploadToQiNiu(file);
        await savePhoneFile(examId, data.url);
        onFinished();
    });

    useEffect(() => {
        doSaveFile();
    }, []);

    return (
        <div className={styles.root}>
            <Spin spinning={loading}>
                <img className={styles.image} src={base64} alt="" />
            </Spin>

            {error && <div className={styles.error}>{errorMessage(error)}</div>}
        </div>
    );
}
